import { useEffect, useState } from "react";
import {
  fetchAiFeatures,
  createAiFeature,
  deleteAiFeature,
} from "@/api/auth";

export default function AiFeatures() {
  const [features, setFeatures] = useState([]);
  const [form, setForm] = useState({
    title: "",
    description: "",
    icon: "",
    badge: "",
    order: 0,
    is_active: true,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // تحميل الميزات
  const loadFeatures = async () => {
    try {
      const data = await fetchAiFeatures();
      setFeatures(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadFeatures();
  }, []);

  // إضافة ميزة
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await createAiFeature(form);

      setForm({
        title: "",
        description: "",
        icon: "",
        badge: "",
        order: 0,
        is_active: true,
      });

      loadFeatures();
    } catch (e) {
      console.error(e);
      setError("فشل إضافة الميزة");
    } finally {
      setLoading(false);
    }
  };

  // حذف ميزة
  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من حذف هذه الميزة؟")) return;

    try {
      await deleteAiFeature(id);
      loadFeatures();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="features-container">
      <h2 className="features-title">ميزات الذكاء الاصطناعي</h2>

      {/* ===== إضافة ميزة ===== */}
      <form onSubmit={handleSubmit} className="features-form">
        <div className="form-grid">
          <input
            className="form-input"
            placeholder="عنوان الميزة"
            value={form.title}
            onChange={(e) =>
              setForm({ ...form, title: e.target.value })
            }
            required
          />

          <textarea
            className="form-textarea"
            placeholder="وصف الميزة"
            value={form.description}
            onChange={(e) =>
              setForm({ ...form, description: e.target.value })
            }
            required
          />

          <input
            className="form-input"
            placeholder="اسم الأيقونة (brain, bot, sparkles...)"
            value={form.icon}
            onChange={(e) =>
              setForm({ ...form, icon: e.target.value })
            }
          />

          <input
            className="form-input"
            placeholder="Badge (مثال: GPT-4, NEW)"
            value={form.badge}
            onChange={(e) =>
              setForm({ ...form, badge: e.target.value })
            }
          />

          <input
            className="form-input"
            type="number"
            placeholder="الترتيب"
            value={form.order}
            onChange={(e) =>
              setForm({ ...form, order: Number(e.target.value) })
            }
          />

          <label className="checkbox-label">
            <input
              type="checkbox"
              className="checkbox-input"
              checked={form.is_active}
              onChange={(e) =>
                setForm({ ...form, is_active: e.target.checked })
              }
            />
            <span className="checkbox-text">مفعّلة</span>
          </label>
        </div>

        <button 
          type="submit" 
          disabled={loading} 
          className="submit-btn"
        >
          {loading ? "جارٍ الحفظ..." : "إضافة الميزة"}
        </button>

        {error && <p className="error-message">{error}</p>}
      </form>

      {/* ===== عرض الميزات ===== */}
      <div className="features-grid">
        {features.map((feature) => (
          <div
            key={feature.id}
            className={`feature-card ${!feature.is_active ? "inactive" : ""}`}
          >
            <div className="feature-header">
              <h3 className="feature-title">{feature.title}</h3>
              
              {feature.badge && (
                <span className="feature-badge">
                  {feature.badge}
                </span>
              )}
            </div>

            <p className="feature-description">{feature.description}</p>

            {feature.icon && (
              <div className="feature-icon">
                <span className="icon-label">Icon:</span>
                <span className="icon-name">{feature.icon}</span>
              </div>
            )}

            <div className="feature-meta">
              <span className="meta-item">الترتيب: {feature.order}</span>
              <span className="meta-item">
                الحالة: {feature.is_active ? "مفعّلة" : "مخفية"}
              </span>
            </div>

            <button
              className="delete-btn"
              onClick={() => handleDelete(feature.id)}
            >
              حذف
            </button>
          </div>
        ))}
      </div>
      
      {/* إضافة الستايل CSS */}
      <style jsx>{`
        .features-container {
          padding: 2rem;
          max-width: 1200px;
          margin: 0 auto;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .features-title {
          color: #1a365d;
          font-size: 2rem;
          margin-bottom: 2rem;
          text-align: right;
          border-bottom: 2px solid #4299e1;
          padding-bottom: 0.5rem;
        }

        .features-form {
          background: #f7fafc;
          padding: 2rem;
          border-radius: 12px;
          margin-bottom: 3rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .form-input, .form-textarea {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 2px solid #cbd5e0;
          border-radius: 8px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: white;
        }

        .form-input:focus, .form-textarea:focus {
          outline: none;
          border-color: #4299e1;
          box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
        }

        .form-textarea {
          min-height: 100px;
          resize: vertical;
          grid-column: 1 / -1;
        }

        .checkbox-label {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          cursor: pointer;
          user-select: none;
        }

        .checkbox-input {
          width: 18px;
          height: 18px;
          accent-color: #4299e1;
        }

        .checkbox-text {
          font-size: 1rem;
          color: #2d3748;
        }

        .submit-btn {
          background: #4299e1;
          color: white;
          border: none;
          padding: 0.875rem 2rem;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 150px;
        }

        .submit-btn:hover:not(:disabled) {
          background: #3182ce;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3);
        }

        .submit-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .error-message {
          color: #e53e3e;
          margin-top: 1rem;
          padding: 0.75rem;
          background: #fed7d7;
          border-radius: 6px;
          border-right: 4px solid #e53e3e;
          text-align: right;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .feature-card {
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 1.5rem;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .feature-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          border-color: #4299e1;
        }

        .feature-card.inactive {
          opacity: 0.7;
          background: #f7fafc;
        }

        .feature-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 1rem;
        }

        .feature-title {
          color: #2d3748;
          font-size: 1.25rem;
          font-weight: 600;
          margin: 0;
          flex: 1;
        }

        .feature-badge {
          background: linear-gradient(135deg, #4299e1, #3182ce);
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 600;
          margin-right: 0.5rem;
        }

        .feature-description {
          color: #4a5568;
          line-height: 1.6;
          margin-bottom: 1rem;
          min-height: 60px;
        }

        .feature-icon {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 1rem;
          padding: 0.5rem;
          background: #edf2f7;
          border-radius: 6px;
        }

        .icon-label {
          color: #718096;
          font-size: 0.875rem;
        }

        .icon-name {
          color: #2d3748;
          font-weight: 500;
        }

        .feature-meta {
          display: flex;
          justify-content: space-between;
          margin-bottom: 1rem;
          padding-top: 1rem;
          border-top: 1px solid #e2e8f0;
        }

        .meta-item {
          color: #718096;
          font-size: 0.875rem;
        }

        .delete-btn {
          width: 100%;
          background: #fc8181;
          color: white;
          border: none;
          padding: 0.75rem;
          border-radius: 8px;
          font-size: 0.875rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .delete-btn:hover {
          background: #e53e3e;
          transform: translateY(-1px);
        }

        /* تخصيصات للعرض على الشاشات الصغيرة */
        @media (max-width: 768px) {
          .features-container {
            padding: 1rem;
          }
          
          .features-form {
            padding: 1.5rem;
          }
          
          .form-grid {
            grid-template-columns: 1fr;
          }
          
          .features-grid {
            grid-template-columns: 1fr;
          }
        }

        /* تأثيرات إضافية */
        .feature-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #4299e1, #38b2ac);
          border-radius: 12px 12px 0 0;
        }

        .feature-card.inactive::before {
          background: #a0aec0;
        }
      `}</style>
    </div>
  );
}